var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFireworkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 383.29 335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#radial-gradient-99);\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient-39);\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient-46);\n      }\n\n      .cls-4 {\n        fill: url(#radial-gradient-7);\n      }\n\n      .cls-5 {\n        fill: url(#radial-gradient-91);\n      }\n\n      .cls-6 {\n        fill: url(#radial-gradient-34);\n      }\n\n      .cls-7 {\n        fill: url(#radial-gradient-10);\n      }\n\n      .cls-8 {\n        fill: url(#radial-gradient-47);\n      }\n\n      .cls-9 {\n        fill: url(#radial-gradient-48);\n      }\n\n      .cls-10 {\n        fill: url(#radial-gradient-31);\n      }\n\n      .cls-11 {\n        fill: url(#radial-gradient-72);\n      }\n\n      .cls-12 {\n        fill: url(#radial-gradient-100);\n      }\n\n      .cls-13 {\n        fill: url(#radial-gradient-94);\n      }\n\n      .cls-14 {\n        fill: url(#radial-gradient-101);\n      }\n\n      .cls-15 {\n        fill: url(#radial-gradient-108);\n      }\n\n      .cls-16 {\n        fill: url(#radial-gradient-28);\n      }\n\n      .cls-17 {\n        fill: url(#radial-gradient-103);\n      }\n\n      .cls-18 {\n        fill: url(#radial-gradient-89);\n      }\n\n      .cls-19 {\n        fill: url(#radial-gradient-65);\n      }\n\n      .cls-20 {\n        fill: url(#radial-gradient-16);\n      }\n\n      .cls-21 {\n        fill: url(#radial-gradient-57);\n      }\n\n      .cls-22 {\n        fill: url(#radial-gradient-50);\n      }\n\n      .cls-23 {\n        fill: url(#radial-gradient-20);\n      }\n\n      .cls-24 {\n        fill: url(#radial-gradient-21);\n      }\n\n      .cls-25 {\n        fill: url(#radial-gradient-8);\n      }\n\n      .cls-26 {\n        fill: url(#radial-gradient-5);\n      }\n\n      .cls-27 {\n        fill: url(#radial-gradient-98);\n      }\n\n      .cls-28 {\n        fill: url(#radial-gradient-4);\n      }\n\n      .cls-29 {\n        fill: url(#radial-gradient-88);\n      }\n\n      .cls-30 {\n        fill: url(#radial-gradient-90);\n      }\n\n      .cls-31 {\n        fill: url(#radial-gradient-67);\n      }\n\n      .cls-32 {\n        fill: url(#radial-gradient-68);\n      }\n\n      .cls-33 {\n        fill: url(#radial-gradient-40);\n      }\n\n      .cls-34 {\n        fill: url(#radial-gradient-96);\n      }\n\n      .cls-35 {\n        fill: url(#radial-gradient-64);\n      }\n\n      .cls-36 {\n        fill: url(#radial-gradient-97);\n      }\n\n      .cls-37 {\n        fill: url(#radial-gradient-32);\n      }\n\n      .cls-38 {\n        fill: url(#radial-gradient-78);\n      }\n\n      .cls-39 {\n        fill: url(#radial-gradient-52);\n      }\n\n      .cls-40 {\n        fill: url(#radial-gradient-54);\n      }\n\n      .cls-41 {\n        fill: url(#radial-gradient-76);\n      }\n\n      .cls-42 {\n        fill: url(#radial-gradient-25);\n      }\n\n      .cls-43 {\n        fill: url(#radial-gradient-26);\n      }\n\n      .cls-44 {\n        fill: url(#radial-gradient-22);\n      }\n\n      .cls-45 {\n        fill: url(#radial-gradient-6);\n      }\n\n      .cls-46 {\n        fill: url(#radial-gradient-19);\n      }\n\n      .cls-47 {\n        fill: url(#radial-gradient-60);\n      }\n\n      .cls-48 {\n        fill: url(#radial-gradient-110);\n      }\n\n      .cls-49 {\n        fill: url(#radial-gradient-12);\n      }\n\n      .cls-50 {\n        fill: url(#radial-gradient-55);\n      }\n\n      .cls-51 {\n        fill: url(#radial-gradient-49);\n      }\n\n      .cls-52 {\n        fill: url(#radial-gradient-41);\n      }\n\n      .cls-53 {\n        fill: url(#radial-gradient-35);\n      }\n\n      .cls-54 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-55 {\n        fill: url(#radial-gradient-75);\n      }\n\n      .cls-56 {\n        fill: url(#radial-gradient-79);\n      }\n\n      .cls-57 {\n        fill: url(#radial-gradient-81);\n      }\n\n      .cls-58 {\n        fill: url(#radial-gradient-27);\n      }\n\n      .cls-59 {\n        fill: url(#radial-gradient-13);\n      }\n\n      .cls-60 {\n        fill: url(#radial-gradient-69);\n      }\n\n      .cls-61 {\n        fill: url(#radial-gradient-102);\n      }\n\n      .cls-62 {\n        fill: url(#radial-gradient-105);\n      }\n\n      .cls-63 {\n        fill: url(#radial-gradient-74);\n      }\n\n      .cls-64 {\n        fill: url(#radial-gradient-109);\n      }\n\n      .cls-65 {\n        fill: url(#radial-gradient-92);\n      }\n\n      .cls-66 {\n        fill: url(#radial-gradient-104);\n      }\n\n      .cls-67 {\n        fill: url(#radial-gradient-43);\n      }\n\n      .cls-68 {\n        fill: url(#radial-gradient-30);\n      }\n\n      .cls-69 {\n        fill: url(#radial-gradient-66);\n      }\n\n      .cls-70 {\n        fill: url(#radial-gradient-86);\n      }\n\n      .cls-71 {\n        fill: url(#radial-gradient-95);\n      }\n\n      .cls-72 {\n        fill: url(#radial-gradient-51);\n      }\n\n      .cls-73 {\n        fill: url(#radial-gradient-61);\n      }\n\n      .cls-74 {\n        fill: url(#radial-gradient-24);\n      }\n\n      .cls-75 {\n        fill: url(#radial-gradient-58);\n      }\n\n      .cls-76 {\n        fill: url(#radial-gradient-87);\n      }\n\n      .cls-77 {\n        fill: url(#radial-gradient-15);\n      }\n\n      .cls-78 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-79 {\n        fill: url(#radial-gradient-93);\n      }\n\n      .cls-80 {\n        fill: url(#radial-gradient-106);\n      }\n\n      .cls-81 {\n        fill: url(#radial-gradient-38);\n      }\n\n      .cls-82 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-83 {\n        fill: url(#radial-gradient-80);\n      }\n\n      .cls-84 {\n        fill: url(#radial-gradient-56);\n      }\n\n      .cls-85 {\n        fill: url(#radial-gradient-42);\n      }\n\n      .cls-86 {\n        fill: url(#radial-gradient-53);\n      }\n\n      .cls-87 {\n        fill: url(#radial-gradient-45);\n      }\n\n      .cls-88 {\n        fill: url(#radial-gradient-17);\n      }\n\n      .cls-89 {\n        fill: url(#radial-gradient-85);\n      }\n\n      .cls-90 {\n        fill: url(#radial-gradient-33);\n      }\n\n      .cls-91 {\n        fill: url(#radial-gradient-84);\n      }\n\n      .cls-92 {\n        fill: url(#radial-gradient-14);\n      }\n\n      .cls-93 {\n        fill: url(#radial-gradient-83);\n      }\n\n      .cls-94 {\n        fill: url(#radial-gradient-107);\n      }\n\n      .cls-95 {\n        fill: url(#radial-gradient-37);\n      }\n\n      .cls-96 {\n        fill: url(#radial-gradient-71);\n      }\n\n      .cls-97 {\n        fill: url(#radial-gradient-29);\n      }\n\n      .cls-98 {\n        fill: url(#radial-gradient-62);\n      }\n\n      .cls-99 {\n        fill: url(#radial-gradient-82);\n      }\n\n      .cls-100 {\n        fill: url(#radial-gradient-59);\n      }\n\n      .cls-101 {\n        fill: url(#radial-gradient-23);\n      }\n\n      .cls-102 {\n        fill: url(#radial-gradient-63);\n      }\n\n      .cls-103 {\n        fill: url(#radial-gradient-36);\n      }\n\n      .cls-104 {\n        fill: url(#radial-gradient-70);\n      }\n\n      .cls-105 {\n        fill: url(#radial-gradient-11);\n      }\n\n      .cls-106 {\n        fill: url(#radial-gradient-18);\n      }\n\n      .cls-107 {\n        fill: url(#radial-gradient-77);\n      }\n\n      .cls-108 {\n        fill: url(#radial-gradient-9);\n      }\n\n      .cls-109 {\n        fill: url(#radial-gradient-73);\n      }\n\n      .cls-110 {\n        fill: url(#radial-gradient-44);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 99.46,
    cy: 197.09,
    fx: 99.46,
    fy: 197.09,
    r: 2.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5ff55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00aa9e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 117.52,
    cy: 261.21,
    fx: 117.52,
    fy: 261.21,
    r: 2.78,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 71.91,
    cy: 181.32,
    fx: 71.91,
    fy: 181.32,
    r: 2.77,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 183.84,
    cy: 169.21,
    fx: 183.84,
    fy: 169.21,
    r: 9.31,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 20.62,
    cy: 205.28,
    fx: 20.62,
    fy: 205.28,
    r: 9.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 216.3,
    cy: 158.89,
    fx: 216.3,
    fy: 158.89,
    r: 6.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 258.73,
    cy: 93.17,
    fx: 258.73,
    fy: 93.17,
    r: 16.98,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 224.85,
    cy: 123.11,
    fx: 224.85,
    fy: 123.11,
    r: 14.88,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 265.01,
    cy: 133.13,
    fx: 265.01,
    fy: 133.13,
    r: 13.21,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 102.65,
    cy: 137.06,
    fx: 102.65,
    fy: 137.06,
    r: 13.2,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 284.68,
    cy: 46.26,
    fx: 284.68,
    fy: 46.26,
    r: 13.14,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 353.07,
    cy: 165.38,
    fx: 353.07,
    fy: 165.38,
    r: 13.06,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 336.83,
    cy: 237.09,
    fx: 336.83,
    fy: 237.09,
    r: 13.04,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 310.07,
    cy: 109.91,
    fx: 310.07,
    fy: 109.91,
    r: 26.88,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 264.74,
    cy: 165.36,
    fx: 264.74,
    fy: 165.36,
    r: 17.79,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 295.93,
    cy: 164.7,
    fx: 295.93,
    fy: 164.7,
    r: 20.16,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 334.2,
    cy: 124.62,
    fx: 334.2,
    fy: 124.62,
    r: 22.22,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 353.03,
    cy: 148.87,
    fx: 353.03,
    fy: 148.87,
    r: 22.75,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 301.75,
    cy: 204.8,
    fx: 301.75,
    fy: 204.8,
    r: 18.14,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 288.9,
    cy: 196.44,
    fx: 288.9,
    fy: 196.44,
    r: 16.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 239.74,
    cy: 315.89,
    fx: 239.74,
    fy: 315.89,
    r: 16.65,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 89.81,
    cy: 285.56,
    fx: 89.81,
    fy: 285.56,
    r: 16.57,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 261.76,
    cy: 45.51,
    fx: 261.76,
    fy: 45.51,
    r: 14.68,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 303.81,
    cy: 60.89,
    fx: 303.81,
    fy: 60.89,
    r: 15.92,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 246.73,
    cy: 34.55,
    fx: 246.73,
    fy: 34.55,
    r: 17.93,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 214.75,
    cy: 67.3,
    fx: 214.75,
    fy: 67.3,
    r: 16.03,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 309.99,
    cy: 83.18,
    fx: 309.99,
    fy: 83.18,
    r: 16.11,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 156.61,
    cy: 77.81,
    fx: 156.61,
    fy: 77.81,
    r: 18.33,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 174.29,
    cy: 108.87,
    fx: 174.29,
    fy: 108.87,
    r: 18.41,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 185.53,
    cy: 37.75,
    fx: 185.53,
    fy: 37.75,
    r: 18.41,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 132.13,
    cy: 43.45,
    fx: 132.13,
    fy: 43.45,
    r: 18.53,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 215.52,
    cy: 104.72,
    fx: 215.52,
    fy: 104.72,
    r: 19.94,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 205.69,
    cy: 27.64,
    fx: 205.69,
    fy: 27.64,
    r: 19.9,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 165.19,
    cy: 35.49,
    fx: 165.19,
    fy: 35.49,
    r: 25.67,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: 142.85,
    cy: 123.95,
    fx: 142.85,
    fy: 123.95,
    r: 9.92,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 148.17,
    cy: 160.04,
    fx: 148.17,
    fy: 160.04,
    r: 7.66,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: 239.79,
    cy: 229.41,
    fx: 239.79,
    fy: 229.41,
    r: 7.87,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: 120.7,
    cy: 116.83,
    fx: 120.7,
    fy: 116.83,
    r: 9.62,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: 84.44,
    cy: 63.3,
    fx: 84.44,
    fy: 63.3,
    r: 16.26,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: 116.76,
    cy: 61.41,
    fx: 116.76,
    fy: 61.41,
    r: 26.24,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: 56.9,
    cy: 100.56,
    fx: 56.9,
    fy: 100.56,
    r: 19.61,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: 72.9,
    cy: 94.91,
    fx: 72.9,
    fy: 94.91,
    r: 14.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: 71.98,
    cy: 76.07,
    fx: 71.98,
    fy: 76.07,
    r: 18.4,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: 111.02,
    cy: 290.1,
    fx: 111.02,
    fy: 290.1,
    r: 14.75,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: 287.97,
    cy: 290.55,
    fx: 287.97,
    fy: 290.55,
    r: 14.67,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: 57.13,
    cy: 250.5,
    fx: 57.13,
    fy: 250.5,
    r: 15.31,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: 33.34,
    cy: 186.8,
    fx: 33.34,
    fy: 186.8,
    r: 19.4,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-48",
    cx: 80.36,
    cy: 170.4,
    fx: 80.36,
    fy: 170.4,
    r: 16.62,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-49",
    cx: 36.9,
    cy: 137.15,
    fx: 36.9,
    fy: 137.15,
    r: 15.57,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-50",
    cx: 45.18,
    cy: 121,
    fx: 45.18,
    fy: 121,
    r: 17.98,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-51",
    cx: 107.53,
    cy: 164.7,
    fx: 107.53,
    fy: 164.7,
    r: 13.71,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-52",
    cx: 33.4,
    cy: 165.93,
    fx: 33.4,
    fy: 165.93,
    r: 13.83,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-53",
    cx: 357.18,
    cy: 179.9,
    fx: 357.18,
    fy: 179.9,
    r: 18.78,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-54",
    cx: 344.15,
    cy: 222.21,
    fx: 344.15,
    fy: 222.21,
    r: 19.47,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-55",
    cx: 41.66,
    cy: 222.23,
    fx: 41.66,
    fy: 222.23,
    r: 19.7,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-56",
    cx: 301.73,
    cy: 254.19,
    fx: 301.73,
    fy: 254.19,
    r: 15.38,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-57",
    cx: 83.62,
    cy: 268.25,
    fx: 83.62,
    fy: 268.25,
    r: 15.49,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-58",
    cx: 304.97,
    cy: 274.68,
    fx: 304.97,
    fy: 274.68,
    r: 17.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-59",
    cx: 246.71,
    cy: 295.09,
    fx: 246.71,
    fy: 295.09,
    r: 18.62,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-60",
    cx: 157.15,
    cy: 299.74,
    fx: 157.15,
    fy: 299.74,
    r: 20.57,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-61",
    cx: 194.44,
    cy: 312.34,
    fx: 194.44,
    fy: 312.34,
    r: 12.89,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-62",
    cx: 222.5,
    cy: 312.28,
    fx: 222.5,
    fy: 312.28,
    r: 16.94,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-63",
    cx: 130.92,
    cy: 201.02,
    fx: 130.92,
    fy: 201.02,
    r: 11.22,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-64",
    cx: 254.01,
    cy: 197.12,
    fx: 254.01,
    fy: 197.12,
    r: 11.26,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-65",
    cx: 170.04,
    cy: 201.68,
    fx: 170.04,
    fy: 201.68,
    r: 7,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-66",
    cx: 167.84,
    cy: 257.22,
    fx: 167.84,
    fy: 257.22,
    r: 6.97,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-67",
    cx: 214.04,
    cy: 206.7,
    fx: 214.04,
    fy: 206.7,
    r: 8.78,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-68",
    cx: 225.6,
    cy: 256.38,
    fx: 225.6,
    fy: 256.38,
    r: 10.03,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-69",
    cx: 140.33,
    cy: 233.83,
    fx: 140.33,
    fy: 233.83,
    r: 10.2,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-70",
    cx: 276.72,
    cy: 226.18,
    fx: 276.72,
    fy: 226.18,
    r: 10.2,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-71",
    cx: 105.18,
    cy: 220.07,
    fx: 105.18,
    fy: 220.07,
    r: 16.91,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-72",
    cx: 360.85,
    cy: 199.56,
    fx: 360.85,
    fy: 199.56,
    r: 12.07,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-73",
    cx: 16.66,
    cy: 148.22,
    fx: 16.66,
    fy: 148.22,
    r: 12.07,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-74",
    cx: 45.29,
    cy: 236.7,
    fx: 45.29,
    fy: 236.7,
    r: 12.13,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-75",
    cx: 284.31,
    cy: 102.92,
    fx: 284.31,
    fy: 102.92,
    r: 3.54,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-76",
    cx: 269.07,
    cy: 243.72,
    fx: 269.07,
    fy: 243.72,
    r: 3.54,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-77",
    cx: 235.45,
    cy: 131.79,
    fx: 235.45,
    fy: 131.79,
    r: 2.07,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-78",
    cx: 191.38,
    cy: 130.22,
    fx: 191.38,
    fy: 130.22,
    r: 2.08,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-79",
    cx: 77.77,
    cy: 193.55,
    fx: 77.77,
    fy: 193.55,
    r: 2.07,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-80",
    cx: 229.77,
    cy: 39.86,
    fx: 229.77,
    fy: 39.86,
    r: 2.08,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-81",
    cx: 254.06,
    cy: 211.8,
    fx: 254.06,
    fy: 211.8,
    r: 2.08,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-82",
    cx: 130.9,
    cy: 143.24,
    fx: 130.9,
    fy: 143.24,
    r: 2.07,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-83",
    cx: 263.4,
    cy: 260.94,
    fx: 263.4,
    fy: 260.94,
    r: 2.08,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-84",
    cx: 295.52,
    cy: 141.41,
    fx: 295.52,
    fy: 141.41,
    r: 2.08,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-85",
    cx: 267,
    cy: 103,
    fx: 267,
    fy: 103,
    r: 2.08,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-86",
    cx: 192.95,
    cy: 100.78,
    fx: 192.95,
    fy: 100.78,
    r: 2.08,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-87",
    cx: 237.54,
    cy: 75.98,
    fx: 237.54,
    fy: 75.98,
    r: 2.07,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-88",
    cx: 329.09,
    cy: 143.5,
    fx: 329.09,
    fy: 143.5,
    r: 2.08,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-89",
    cx: 69.36,
    cy: 256.82,
    fx: 69.36,
    fy: 256.82,
    r: 2.08,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-90",
    cx: 111.73,
    cy: 233.85,
    fx: 111.73,
    fy: 233.85,
    r: 2.07,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-91",
    cx: 98.97,
    cy: 102.8,
    fx: 98.97,
    fy: 102.8,
    r: 2.07,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-92",
    cx: 250.26,
    cy: 159.93,
    fx: 250.26,
    fy: 159.93,
    r: 2.77,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-93",
    cx: 142.83,
    cy: 277.57,
    fx: 142.83,
    fy: 277.57,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-94",
    cx: 147.02,
    cy: 94.97,
    fx: 147.02,
    fy: 94.97,
    r: 2.76,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-95",
    cx: 203.04,
    cy: 265.93,
    fx: 203.04,
    fy: 265.93,
    r: 2.77,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-96",
    cx: 282.26,
    cy: 85.21,
    fx: 282.26,
    fy: 85.21,
    r: 2.77,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-97",
    cx: 96.78,
    cy: 244.99,
    fx: 96.78,
    fy: 244.99,
    r: 2.78,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-98",
    cx: 76.62,
    cy: 133.11,
    fx: 76.62,
    fy: 133.11,
    r: 2.77,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-99",
    cx: 311.92,
    cy: 176.33,
    fx: 311.92,
    fy: 176.33,
    r: 2.71,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-100",
    cx: 194.47,
    cy: 78.93,
    fx: 194.47,
    fy: 78.93,
    r: 2.78,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-101",
    cx: 251.9,
    cy: 274.7,
    fx: 251.9,
    fy: 274.7,
    r: 2.76,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-102",
    cx: 239.69,
    cy: 94.09,
    fx: 239.69,
    fy: 94.09,
    r: 2.71,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-103",
    cx: 56.95,
    cy: 205.19,
    fx: 56.95,
    fy: 205.19,
    r: 2.71,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-104",
    cx: 130.88,
    cy: 296.78,
    fx: 130.88,
    fy: 296.78,
    r: 2.71,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-105",
    cx: 195.78,
    cy: 281.87,
    fx: 195.78,
    fy: 281.87,
    r: 2.71,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-106",
    cx: 208.47,
    cy: 281.87,
    fx: 208.47,
    fy: 281.87,
    r: 2.71,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-107",
    cx: 249.76,
    cy: 247.58,
    fx: 249.76,
    fy: 247.58,
    r: 2.71,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-108",
    cx: 67.41,
    cy: 145.71,
    fx: 67.41,
    fy: 145.71,
    r: 2.71,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-109",
    cx: 109.63,
    cy: 92.01,
    fx: 109.63,
    fy: 92.01,
    r: 2.07,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-110",
    cx: 109.88,
    cy: 67.55,
    fx: 109.88,
    fy: 67.55,
    r: 2.78,
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Green"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m99.92,199.94s-3.73.72-3.01-3.21c.72-4.06,4.25-2.29,4.65-1.24.39.98,1.57,3.93-1.64,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m117.98,264.06s-3.73.72-3.01-3.21c.72-4.06,4.25-2.29,4.65-1.24.39.98,1.64,3.93-1.64,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m72.37,184.17s-3.73.72-3.01-3.21c.72-4.06,4.25-2.29,4.65-1.24.39.98,1.57,3.93-1.64,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m181.11,181.95s10.73-23.95,3.66-25.39c-7.07-1.37-3.14,13.61-3.66,25.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m33.38,203.34s-25.84-4.78-25.52,2.42c.2,7.07,13.81-.26,25.52-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m210.16,165.92s3.79-5.82,10.01-8.24c6.22-2.42-1.96-7.92-5.04-4.97-2.94,3.01-4.51,7.85-4.97,13.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m245.76,113.38s17.99-30.95,23.29-33.63c5.3-2.75,1.7-8.44-2.55-6.35-4.19,2.09-17.34,23.29-20.74,39.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m214.29,141.32s10.4-23.88,16.68-27.94c6.35-4.06,5.5-8.9,0-8.44-5.5.46-14.66,20.67-16.68,36.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m251.32,145.83s17.6-18.19,23.75-19.24c6.15-1.05,3.34-5.89,0-6.15-3.4-.26-12.37,2.42-23.75,25.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m116.34,149.76s-17.6-18.19-23.75-19.24c-6.15-1.05-3.34-5.89,0-6.15,3.4-.2,12.3,2.55,23.75,25.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m273.76,61.3s13.09-21.66,18.84-24.01c5.76-2.42,2.03-6.54-1.37-6.02-3.27.52-11.38,5.17-17.47,30.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m335.59,171.35s24.21-7.33,30.1-5.3c5.89,2.09,5.82-3.53,3.01-5.36-2.94-1.83-12.04-3.79-33.11,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m319.03,235.66s25.32.98,30.16,4.84c4.84,3.93,6.67-1.44,4.58-4.12-2.09-2.55-10.14-7.39-34.74-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m281.15,134.58s40.24-38.54,50.38-41.42c10.21-2.81,8.9-8.18,2.29-7.92-6.54.2-37.03,24.8-52.67,49.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m247.26,183.45s20.74-21.79,28.98-26.96c8.24-5.17,6.87-8.77,2.42-9.23-4.51-.39-19.56,13.54-31.4,36.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m271.99,180.18s24.47-21.46,39.26-22.9c14.72-1.44,7.26-9.42,2.03-7.85-5.3,1.57-19.04,6.02-41.28,30.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m307.58,141.32s33.63-21.2,44.23-24.08c10.66-2.94,10.4-7.39,6.61-9.16-3.86-1.64-26.11,9.55-50.84,33.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m323.68,162.06s35.98-18.45,54.24-18.19c0,0,8.44-1.5,2.09-6.94-6.41-5.56-33.69,8.18-56.33,25.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m276.7,210.34s26.89-5.69,41.48-3.14c14.59,2.55,6.94-6.15,3.79-7.2s-16.49-3.01-45.28,10.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m266.95,204.78s19.89-10.93,33.63-10.53c13.81.46,10.99-4.84,6.94-5.89-4.06-1.05-22.38.26-40.56,16.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m226,296.77s16.16,15.96,19.76,29.18c3.6,13.28,7.79,9.16,7.72,5.04-.07-4.12-6.74-21.46-27.48-34.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m108.62,271.58s-20.54,9.68-28.33,21.07c-7.72,11.38-10.4,6.08-8.9,2.16,1.5-3.93,13.41-17.99,37.23-23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m251.32,63.46s8.44-18.45,16.95-25.19c8.44-6.74,1.37-12.04-3.27-10.4-4.58,1.77-12.82,27.54-13.67,35.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m288.28,77.2s15.05-21.59,23.49-24.34c8.44-2.75,9.75-7.65,4.25-8.24-5.5-.65-15.44,6.8-27.74,32.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m236.86,57.9s10.99-27.35,16.09-35.79,4.65-11.58,0-10.8c-4.65.92-11.19,20.81-16.09,46.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m209.38,89.11s6.74-24.99,10.53-35.59c3.79-10.53-3.73-9.55-5.69-3.6-3.08,9.55-7.59,25.19-4.84,39.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m293.39,98.79s19.63-16.81,28.72-23.42c9.16-6.61,2.22-10.01-2.68-6.22-7.92,6.15-20.41,16.55-26.04,29.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m160.5,103.04s-5.1-35.59-7.98-39.58c-3.01-4.06-2.29-11.84,2.09-10.8,4.38,1.05,11.38,30.55,5.89,50.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m175.55,134.58s-3.14-34.74-4.84-41.42c-1.7-6.67.59-11.78,4.84-9.42,4.25,2.29,3.4,42.99,0,50.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m186.81,63.46s-3.14-34.74-4.84-41.42.59-11.78,4.84-9.42c4.25,2.36,3.34,43.05,0,50.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m143.36,67.12s-15.64-31.14-19.69-36.77c-4.06-5.63-3.66-11.19,1.11-10.53,4.78.59,18.91,38.86,18.58,47.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m204.28,130.59s14.72-33.89,18.19-39.19c7.2-10.86,4.06-14.07,0-11.91-3.99,2.22-10.73,9.55-18.19,51.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "m201.53,55.28s5.63-36.51,7.65-42.53c4.19-12.37.33-14.59-3.01-11.52s-7.98,11.97-4.65,54.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m173.92,70.72s-.72-64.12-12.37-69.81c-11.65-5.69.13,27.48,1.9,33.04,1.7,5.56,9.88,32.19,10.47,36.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m150.63,135.63s-.52-22.25-11.91-23.29c-11.45-1.05,7.33,13.41,11.91,23.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "m155.21,168.21s1.7-15.51-10.4-16.29c-12.17-.85,9.09,10.34,10.4,16.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m229.79,227.03s13.61-7.46,19.04,3.34c5.37,10.93-13.09-4.45-19.04-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m130.87,125.88s-7.2-19.63-17.14-17.99c-9.94,1.7,5.5,8.24,17.14,17.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m98.87,81.19s-13.09-37.36-24.8-35.72c-11.58,1.64,4.84,8.24,7.2,10.93,2.42,2.81,18.25,22.9,17.6,24.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m135.97,93.16s-13.54-61.04-32.19-63.33,9.75,19.56,17.6,31.6c5.43,8.44,12.23,25.06,14.59,31.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m77.67,118.94s-27.35-39.19-41.28-36.64c0,0-3.01,2.94,11.25,10.86,14.2,7.92,30.03,25.78,30.03,25.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "m88.73,107.82s-16.09-27.68-28.59-25.71c-12.5,2.09,16.36,13.41,28.59,25.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m89.84,95s-21.2-44.62-34.74-36.97c0,0-5.3,2.75,8.7,9.36,13.94,6.54,26.04,27.61,26.04,27.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "m125.04,274.66s-17.21,20.74-20.35,27.28c-3.08,6.54-9.29,3.34-7.33-3.08,1.96-6.54,14.98-14.98,27.68-24.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m271.4,278.06s21.26,16.62,25.58,22.31c4.45,5.69,9.81,1.37,6.54-4.58-3.34-6.02-17.86-11.52-32.12-17.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m77.67,244.63s-27.35-5.1-38.86,8.18c-11.52,13.28,24.73-6.74,38.86-8.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m59.94,193.53s-34.94-20.09-52.8-11.19c0,0-3.66,3.99,10.99,4.45,14.72.52,41.81,6.74,41.81,6.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m100.84,181.95s-26.24-27.41-38.27-22.51c-12.04,4.91,19.43,5.17,38.27,22.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m57.13,145.83s-30.55-21.39-39.91-16.68c0,0-4.06,3.47,9.75,6.61,13.74,3.08,30.16,10.08,30.16,10.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m66.68,134.58s-25.58-31.01-42.13-26.76c0,0-5.36,3.73,10.53,7.46,16.09,3.73,31.6,19.3,31.6,19.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m122.95,176.45s-13.87-22.64-25.45-23.42c-11.58-.85-1.7,5.69,3.6,7.2,5.3,1.44,21.85,16.23,21.85,16.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m52.03,171.87s-21.72-15.11-32.71-11.25c-10.99,3.93.72,5.89,6.22,5.17,5.36-.79,26.5,6.08,26.5,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m331.07,184.76s26.3-12.5,44.03-9.16c17.73,3.34,2.29,6.74-5.5,6.35-7.85-.39-38.54,2.81-38.54,2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m316.94,223.89s32.71-11.71,51.23-2.09c9.94,5.17-5.69,6.22-15.9,2.09-8.37-3.34-35.33,0-35.33,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m68.58,216.62s-34.15-6.28-50.9,6.08c-8.96,6.67,4.45,11.19,16.03-.46,6.35-6.28,34.87-5.63,34.87-5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m281.02,247.57s39.58-.85,41.28,9.49c1.7,10.34-12.5-3.6-23.49-6.02-8.05-1.7-17.8-3.47-17.8-3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m102.6,257.32s-39.06,4.51-37.95,18.78c.85,10.47,13.48-8.77,22.7-12.63,7.65-3.27,15.24-6.15,15.24-6.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m282.98,263.01s53.32,17.21,42.53,22.64c-6.8,3.34-12.95-6.15-20.41-10.21-7.52-4.06-22.11-12.43-22.11-12.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m226.78,277.86s49.92,25.52,38.01,33.04c-10.01,6.22-.79-8.7-38.01-33.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m175.95,277.54s-48.61,35.72-35.27,43.12c11.19,6.22-.33-10.27,35.27-43.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m189.23,294.87s15.9,32.12,8.44,34.68c-7.39,2.49-2.03-13.48-8.44-34.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m210.16,291.73s35.27,40.89,21.46,41.09c0,0-3.14-1.24-7.39-13.48-4.45-12.17-14.07-27.61-14.07-27.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m144.21,209.69s-16.29-24.54-26.24-15.24c0,0-2.29,8.18,4.78,4.65,7.07-3.53,21.46,10.6,21.46,10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m242.48,208.12s10.08-27.68,21.92-20.94c0,0,4.19,7.39-3.53,5.63-7.72-1.83-18.38,15.31-18.38,15.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m176.27,209.36s.46-13.61-7.59-15.11c-7.98-1.5-4.78,3.99-.2,7.46,4.58,3.6,7.79,7.65,7.79,7.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m175.62,251.17s-13.54-.72-15.24,7.2c-1.7,7.98,3.93,4.84,7.46.39,3.66-4.45,7.79-7.59,7.79-7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m203.03,212.44s12.37-15.64,19.37-10.4c7.07,5.3-1.9,4.12-4.65,4.65-2.81.52-13.67,4.19-14.72,5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m213.11,250.71s13.67-4.19,21.26,4.12c7.59,8.31,2.42,10.86-5.1,5.3-7.46-5.56-4.58-7.92-16.16-9.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m153.7,231.54s-12.56-6.87-21.72-.2-4.51,10.21,3.93,6.22c8.51-3.93,6.15-6.87,17.8-6.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m263.36,223.89s12.56-6.87,21.72-.2c9.16,6.67,4.51,10.21-3.93,6.22-8.51-3.99-6.15-6.87-17.8-6.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m128.31,218.26s-26.3-11.38-45.54,3.21c0,0-4.78,8.7,9.94,2.29,14.79-6.28,35.59-5.5,35.59-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m344.09,202.36s17.27-11.19,32.65-3.14c0,0,4.45,5.63-6.74,2.81-11.32-2.75-25.91.33-25.91.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "m33.32,151.92s-16.55-12.3-32.32-5.17c0,0-4.78,5.3,6.61,3.21,11.38-2.09,25.71,1.96,25.71,1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m61.78,234.16s-19.3-7.13-32.52,4.06c0,0-3.14,6.41,7.2,1.24s25.32-5.3,25.32-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m284.29,106.38s-3.34-.2-3.6-3.21c-.2-3.01,4.12-5.04,6.02-2.68,1.7,2.16,2.22,5.95-2.42,5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m269.05,247.18s-3.34-.2-3.6-3.21c-.2-3.01,4.12-5.04,6.02-2.68,1.7,2.22,2.22,5.95-2.42,5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m235.88,133.86s-3.34-1.05-2.29-3.01,3.27-.98,3.6,0c.2.98,1.11,2.75-1.31,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m191.78,132.29s-3.34-1.05-2.29-3.01,3.27-.98,3.6,0c.26.98,1.18,2.68-1.31,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m78.2,195.62s-3.34-1.05-2.29-3.01,3.27-.98,3.6,0c.2.92,1.11,2.68-1.31,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m230.18,41.93s-3.34-1.05-2.29-3.01,3.27-.98,3.6,0c.2.92,1.18,2.75-1.31,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m254.46,213.88s-3.34-1.05-2.29-3.01,3.27-.98,3.6,0c.26.98,1.18,2.75-1.31,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m131.32,145.31s-3.34-1.05-2.29-3.01,3.27-.98,3.6,0c.2.92,1.11,2.68-1.31,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "m263.81,263.01s-3.34-1.05-2.29-3.01,3.27-.98,3.6,0c.2.92,1.18,2.68-1.31,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m295.94,143.48s-3.34-1.05-2.29-3.01,3.27-.98,3.6,0c.2.92,1.18,2.75-1.31,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m267.41,105.07s-3.34-1.05-2.29-3.01,3.27-.98,3.6,0c.2.98,1.18,2.81-1.31,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m193.35,102.85s-3.34-1.05-2.29-3.01c1.05-1.96,3.27-.98,3.6,0,.26.98,1.18,2.68-1.31,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m237.97,78.05s-3.34-1.05-2.29-3.01,3.27-.98,3.6,0c.2.98,1.11,2.81-1.31,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m329.5,145.57s-3.34-1.05-2.29-3.01,3.27-.98,3.6,0c.2.92,1.18,2.75-1.31,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m69.76,258.89s-3.34-1.05-2.29-3.01,3.27-.98,3.6,0c.26.98,1.18,2.68-1.31,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m112.15,235.92s-3.34-1.05-2.29-3.01,3.27-.98,3.6,0c.2.92,1.11,2.75-1.31,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m99.4,104.87s-3.34-1.05-2.29-3.01,3.27-.98,3.6,0c.2.98,1.11,2.75-1.31,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m250.73,162.78s-3.73.72-3.01-3.21c.72-4.06,4.25-2.29,4.65-1.24s1.57,3.93-1.64,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m143.3,280.41s-3.73.72-3.01-3.21c.72-4.06,4.25-2.29,4.65-1.24.39,1.05,1.57,3.99-1.64,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m147.48,97.81s-3.73.72-3.01-3.21c.72-3.99,4.25-2.29,4.65-1.24.39.98,1.57,3.93-1.64,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m203.49,268.77s-3.73.72-3.01-3.21c.72-3.99,4.25-2.29,4.65-1.24.46.92,1.57,3.93-1.64,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m282.72,88.06s-3.73.72-3.01-3.21c.72-4.06,4.25-2.29,4.65-1.24.39,1.05,1.57,3.93-1.64,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m97.24,247.83s-3.73.72-3.01-3.21c.72-4.06,4.25-2.29,4.65-1.24s1.64,3.93-1.64,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m77.09,135.95s-3.73.72-3.01-3.21c.72-4.06,4.25-2.29,4.65-1.24.39.92,1.57,3.93-1.64,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m312.82,178.87s-4.25.72-3.66-3.01c.65-3.73,5.3-1.77,5.56,0,.26,1.9-1.9,3.01-1.9,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m194.92,81.78s-3.73.72-3.01-3.21c.72-4.06,4.25-2.29,4.65-1.24.39.92,1.64,3.93-1.64,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m252.36,277.54s-3.73.72-3.01-3.21c.72-3.99,4.25-2.29,4.65-1.24.39.98,1.57,3.99-1.64,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m240.59,96.63s-4.25.72-3.66-3.01c.65-3.73,5.3-1.77,5.56,0,.33,1.9-1.9,3.01-1.9,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m57.85,207.73s-4.25.72-3.66-3.01c.65-3.73,5.3-1.77,5.56,0,.2,1.83-1.9,3.01-1.9,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m131.78,299.32s-4.25.72-3.66-3.01,5.3-1.77,5.56,0c.2,1.77-1.9,3.01-1.9,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m196.69,284.41s-4.25.72-3.66-3.01c.65-3.73,5.3-1.77,5.56,0,.2,1.83-1.9,3.01-1.9,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m209.38,284.41s-4.25.72-3.66-3.01c.65-3.73,5.3-1.77,5.56,0,.2,1.83-1.9,3.01-1.9,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m250.66,250.12s-4.25.72-3.66-3.01,5.3-1.77,5.56,0-1.9,3.01-1.9,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m68.32,148.25s-4.25.72-3.66-3.01,5.3-1.77,5.56,0c.2,1.83-1.9,3.01-1.9,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m110.06,94.08s-3.34-1.05-2.29-3.01,3.27-.98,3.6,0c.2.98,1.11,2.75-1.31,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m110.32,70.39s-3.73.72-3.01-3.21c.72-4.06,4.25-2.29,4.65-1.24s1.7,3.93-1.64,4.45Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireworkGreen);
export default __webpack_public_path__ + "static/media/firework-green.fc00184250c5843cde38cf811b72b076.svg";
export { ForwardRef as ReactComponent };